import client from './main-client';

export const getPropertyClassesApi = (params) => client()
  .get('/options-property-classes', { params });
